/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { Box, Flex, Text } from '@chakra-ui/react';
import { Chart as ReactChart } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
import { useEffect, useMemo, useRef, useState } from 'react';

import getDashboradChartOptions from 'utils/dashboardChartOptions';
import { getDimFilterWithInstrumentId } from 'redux/DashboardSlice';
import getFilterCondition from 'utils/TimeGranularityCondition';
import {
  getDashboardBlocks,
  getSelectedDashboardScenario,
  resolveIndicatorDimension,
} from 'redux/DashboardSliceV2';
import hasPercentageDataType from 'utils/checkPercentageDataType';

import DASHBOARD_CHART_COLORS from '../chartColors';

const indicatorSeriesName = (indicator: any): string =>
  indicator?.indicator_name ?? indicator?.name ?? '';

interface Properties {
  chartFormatting?: any;
  graphData?: any;
  timeGranularityFilter?: any;
  isDashboardLayout?: boolean;
}
const BarChart = ({
  timeGranularityFilter,
  chartFormatting,
  graphData,
  isDashboardLayout,
}: Properties) => {
  const baseScenario: any = useSelector(getSelectedDashboardScenario);
  const blockDetails = useSelector(getDashboardBlocks);
  const startDateObject = new Date(baseScenario?.start_date);
  startDateObject.setMonth(startDateObject.getMonth() - 1);
  const [chartData, setChartData] = useState<any>([]);
  const [color, setColor] = useState<any>([]);
  const getFilterDatawithInstrumentId = useSelector(getDimFilterWithInstrumentId);
  const [singleIndicatorNoDimData, setSingleIndicatorNoDimData] = useState([]);
  const [multipleIndicatorNoDimData, setMultipleIndicatorNoDimData] = useState<any>([]);
  const [oneDimeensionFilter, setOneDimeensionFilter] = useState<any>([]);
  const [labels, setLabels] = useState([
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]);
  const containereReference = useRef<any>();
  const [width, setWidth] = useState<any>(0);
  const [heightData, setHeight] = useState<any>(0);

  useEffect(() => {
    if (containereReference?.current) {
      const { width, height } = containereReference.current.getBoundingClientRect();
      setWidth(width);
      setHeight(height);
    }
  }, [containereReference?.current, graphData]);
  const filterValues = (values: any[], filterCondition: any) =>
    values.filter((element: any) => filterCondition(element));

  const transArrayData = (data: any, timeGranularityFilter: string) => {
    const DimensionName: any = Array.from(
      new Set(data?.flatMap((element: any) => Object.keys(element))),
    ).find((key: any) => key !== 'values');
    const filterCondition = getFilterCondition(timeGranularityFilter);
    return data?.map((product: any) => ({
      [DimensionName]: product[DimensionName],
      values: filterValues(product.values, filterCondition),
    }));
  };

  const transformMultipleIndicator = (data: any, timeGranularityFilter: string) => {
    const filterCondition = getFilterCondition(timeGranularityFilter);
    return data?.map((indicator: any) => ({
      ...indicator,
      total: filterValues(indicator.total, filterCondition),
    }));
  };

  const transformSingleIndicatorData = (data: any, timeGranularityFilter: string) => {
    const filterCondition = getFilterCondition(timeGranularityFilter);
    return filterValues(data, filterCondition);
  };

  const transformData = (data: any, indicatorName: any) => ({
    name: indicatorName,
    value: data.map((item: any) => ({
      name: item.Time,
      value: item[indicatorName],
    })),
  });

  const fiterGraphData = useMemo(() => {
    if (!graphData || !graphData.data || graphData.data.length === 0) {
      return [];
    }
    const singleIndicatorArray: any = transformSingleIndicatorData(
      graphData?.data[0]?.total,
      timeGranularityFilter,
    );
    setSingleIndicatorNoDimData(singleIndicatorArray);

    const formattedArray = transformMultipleIndicator(graphData?.data, timeGranularityFilter);
    setMultipleIndicatorNoDimData(formattedArray);

    const transformedData = transArrayData(graphData?.data[0].dim_df, timeGranularityFilter);
    setOneDimeensionFilter(transformedData);

    return singleIndicatorArray;
  }, [graphData, timeGranularityFilter]);

  useEffect(() => {
    let filterData = [];
    const colors = graphData?.data?.map((item: any) => item?.indicator?.formatting.color);
    const firstSeries = graphData?.data?.[0];
    const hasDimensionBreakdown =
      firstSeries?.indicator?.dimension_id &&
      firstSeries?.dim_df != null &&
      (Array.isArray(firstSeries.dim_df) ? firstSeries.dim_df.length > 0 : true);

    if (graphData?.data?.length === 1 && !hasDimensionBreakdown) {
      const chartLabelData = graphData?.data?.map((item: any) =>
        indicatorSeriesName(item?.indicator),
      );
      const chartDatas = transformData(singleIndicatorNoDimData, chartLabelData[0]);
      const labelsItem = singleIndicatorNoDimData?.map((item: any) => item.Time);
      setLabels(labelsItem);
      setColor(colors);
      setChartData([chartDatas]);
    }
    if (graphData?.data?.length === 1 && hasDimensionBreakdown) {
      const indicator = graphData?.data[0]?.indicator;
      const foundDimension = resolveIndicatorDimension({
        blockDetails,
        blockId: indicator.block_id,
        indicatorId: indicator.indicator_id ?? indicator.id,
        dimensionId: indicator.dimension_id,
      });
      const dimensionName = foundDimension?.indicator_dimension_name || indicator?.dimension_name;
      const labelsItem = oneDimeensionFilter?.length
        ? oneDimeensionFilter[0].values?.map((item: any) => item.Time)
        : [];
      setLabels(labelsItem);
      const filterDataWithInstrumentId = getFilterDatawithInstrumentId[graphData?.id];
      filterData =
        filterDataWithInstrumentId?.length > 0 && dimensionName
          ? oneDimeensionFilter?.filter((product: any) =>
              filterDataWithInstrumentId?.some(
                (item: any) => item.status && item.name === product[dimensionName],
              ),
            )
          : oneDimeensionFilter || [];
      const chartLabelData = graphData?.data?.map((item: any) =>
        indicatorSeriesName(item?.indicator),
      );
      const dimColors = graphData?.data?.map((item: any) =>
        item?.indicator?.formatting?.dimensionItems?.map((items: any) => items.color),
      );
      const formattedData = filterData?.map((item: any) => ({
        name: `${chartLabelData} (${dimensionName != null ? item[dimensionName] : ''})`,
        value: item.values.map((value: any) => ({
          name: value.Time,
          value: value[chartLabelData[0]],
        })),
      }));
      setChartData(formattedData);
      setColor(dimColors[0]);
    }
    if (graphData?.data?.length > 1 && !hasDimensionBreakdown) {
      const labelsItem = multipleIndicatorNoDimData[0]?.total?.map((item: any) => item.Time);
      setLabels(labelsItem);
      const chartDatas = multipleIndicatorNoDimData?.map((indicatorObject: any) => {
        const name = indicatorSeriesName(indicatorObject?.indicator);
        const value = indicatorObject?.total.map((totalObject: any) => ({
          name: totalObject?.Time,
          value: totalObject[name],
        }));

        return { name, value };
      });
      setColor(colors);
      setChartData(chartDatas);
    }
    if (graphData?.data?.length > 1 && hasDimensionBreakdown) {
      const indicator = graphData?.data[0]?.indicator;
      const foundDimension = resolveIndicatorDimension({
        blockDetails,
        blockId: indicator.block_id,
        indicatorId: indicator.indicator_id ?? indicator.id,
        dimensionId: indicator.dimension_id,
      });
      const dimensionName = foundDimension?.indicator_dimension_name || indicator?.dimension_name;
      const filterDataWithInstrumentId = getFilterDatawithInstrumentId[graphData?.id];
      filterData =
        filterDataWithInstrumentId?.length > 0 && dimensionName
          ? graphData?.data[0].dim_df?.filter((product: any) =>
              filterDataWithInstrumentId?.some(
                (item: any) => item.status && item.name === product[dimensionName],
              ),
            )
          : graphData?.data[0].dim_df || [];
      const chartLabelData = graphData?.data?.map((item: any) =>
        indicatorSeriesName(item?.indicator),
      );
      const dimColors = graphData?.data?.map((item: any) =>
        item?.indicator?.formatting?.dimensionItems?.map((items: any) => items.color),
      );
      const formattedData = filterData?.map((item: any) => ({
        name: `${chartLabelData} (${dimensionName != null ? item[dimensionName] : ''})`,
        value: item.values.map((value: any) => ({
          name: value.Time,
          value: value[chartLabelData[0]],
        })),
      }));
      setChartData(formattedData);
      setColor(dimColors[0]);
    }
  }, [
    graphData,
    timeGranularityFilter,
    chartFormatting,
    blockDetails,
    oneDimeensionFilter,
    multipleIndicatorNoDimData,
    singleIndicatorNoDimData,
    getFilterDatawithInstrumentId,
  ]);

  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const datasets = chartData?.map((entry: any, index: any) => {
    return {
      label: entry.name,
      data: entry.value.map((value: any) => value.value),
      backgroundColor: DASHBOARD_CHART_COLORS[index % DASHBOARD_CHART_COLORS.length] || '#d116e9',
      borderColor: DASHBOARD_CHART_COLORS[index % DASHBOARD_CHART_COLORS.length],
    };
  });

  const dataOfChart = {
    labels,
    datasets,
  };
  const legendMargin = {
    id: 'legendMargin',
    beforeInit(chart: any) {
      const originalFit = chart.legend.fit;
      chart.legend.fit = function fit() {
        originalFit.bind(chart.legend)();
        // this.height += 25;
      };
    },
  };

  const yearFormat = `FY${startDateObject.getFullYear().toString().slice(-2)}`;

  const quarterFormat = `Q${Math.ceil((startDateObject.getMonth() + 1) / 3)}-${String(
    yearFormat,
  ).slice(-2)}`;

  const monthFormat = `${monthNames[startDateObject.getMonth()]}-${String(yearFormat).slice(-2)}`;
  const chartFilter = 'M';
  const targetDate = () => {
    if (chartFilter === 'M') {
      return monthFormat;
    }
    if (chartFilter === 'Q') {
      return quarterFormat;
    }
    return yearFormat;
  };

  const drawBackgroundPlugin = {
    id: 'drawBackground',
    beforeDraw: ({ ctx, chartArea, data, scales }: any) => {
      ctx.fillStyle = 'transparent';

      const targetLabel = targetDate();
      const targetIndex = data.labels.indexOf(`${targetLabel}`);
      if (targetIndex !== -1) {
        // Get the x-axis pixel position for the specified dataset and index
        const xPosition = scales.x.getPixelForValue(data.labels[targetIndex]);

        ctx.fillStyle = '#EEF2F6';
        ctx.fillRect(
          chartArea.left,
          chartArea.top,
          xPosition - chartArea.left,
          chartArea.bottom - chartArea.top,
        );
      } else {
        ctx.fillRect(
          chartArea.left,
          chartArea.top,
          chartArea.right - chartArea.left,
          chartArea.bottom - chartArea.top,
        );
      }
    },
  };

  const hasPercentageType = useMemo(
    () => hasPercentageDataType(graphData, blockDetails),
    [graphData, blockDetails],
  );

  return (
    <Box minWidth={'100%'} height={'100%'} ref={containereReference}>
      <ReactChart
        type='bar'
        data={dataOfChart}
        options={getDashboradChartOptions({
          chartFormatting,
          chartType: 'bar',
          isLegend: true,
          aspectRatio: width / heightData,
          pageWidth: width,
          pageHeight: heightData,
          legendPosition: { position: 'bottom', align: 'start' },
          hasPercentageDataType: hasPercentageType,
        })}
        plugins={[legendMargin, drawBackgroundPlugin]}
      />
    </Box>
  );
};

export default BarChart;
